import { Table } from '@aws-amplify/ui-react'
import {
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { useContext, useEffect } from 'react'

import {
  PassportContext,
  PassportContextInterface,
} from '../../../providers/Passport/PassportProvider'

export const PassportTable = ({
  patientId,
}: {
  patientId: string | undefined
}) => {
  const { getPassportRecord, passportResponse } = useContext(
    PassportContext
  ) as PassportContextInterface

  useEffect(() => {
    if (patientId) {
      getPassportRecord(parseInt(patientId))
    }
  }, [])

  const {
    peerGroupsHours,
    providerAppointmentHours,
    totalHourRequirement,
    totalHours,
  } = passportResponse

  const tableHeadCellStyle = {
    fontWeight: 900,
    fontSize: 16,
    textAlign: 'center',
  }

  const tableBodyCellStyle = { textAlign: 'center' }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={tableHeadCellStyle}>Peer Group Hours</TableCell>
            <TableCell sx={tableHeadCellStyle}>
              Provider Appointment Hours
            </TableCell>
            <TableCell sx={tableHeadCellStyle}>Total Hours</TableCell>
            <TableCell sx={tableHeadCellStyle}>
              Total Hour Requirement
            </TableCell>
            <TableCell sx={tableHeadCellStyle}>Progress</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          <TableRow>
            <TableCell sx={tableBodyCellStyle}>{peerGroupsHours}</TableCell>
            <TableCell sx={tableBodyCellStyle}>
              {providerAppointmentHours.toFixed(2)}
            </TableCell>
            <TableCell sx={tableBodyCellStyle}>
              {totalHours.toFixed(2)}
            </TableCell>
            <TableCell sx={tableBodyCellStyle}>
              {totalHourRequirement.toFixed(2)}
            </TableCell>
            <TableCell sx={tableBodyCellStyle}>
              {totalHours
                ? Math.min((totalHours / totalHourRequirement) * 100, 100)
                : 0}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
